import { Component, Inject, OnInit } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'required-field-dialog',
  templateUrl: './required-field-dialog.component.html',
  styleUrls: ['./required-field-dialog.component.scss'],
})
export class RequiredFieldDialog implements OnInit {
  field: string;

  constructor(
    public dialogRef: MatDialogRef<RequiredFieldDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    if (this.data) {
      this.field = this.data.charAt(0).toUpperCase() + this.data.slice(1);
    }
  }
}
